module.exports = function () {
    return arguments[0];
};